import React from 'react';

/**
 * Pinpoints
 * Reusable checklist/bulleted points with a circular check icon and consistent alignment.
 *
 * Props:
 * - items: Array<string|ReactNode>
 * - className: string (defaults to 'am-pinpoints')
 * - as: 'ul' | 'ol' (defaults to 'ul')
 * - itemTag: element for text, e.g. 'strong' | 'span' (defaults to 'strong')
 * - iconClass: class applied to the icon span (defaults to 'am-check')
 */
export default function Pinpoints({
  items = [],
  className = 'am-pinpoints',
  as = 'ul',
  itemTag = 'strong',
  iconClass = 'am-check',
}) {
  const ListTag = as;
  const TextTag = itemTag;

  return (
    <ListTag className={className}>
      {items.map((content, idx) => (
        <li key={idx}>
          <span className={iconClass} aria-hidden>
            ✔
          </span>
          <TextTag>{content}</TextTag>
        </li>
      ))}
    </ListTag>
  );
}
